import { render, staticRenderFns } from "./modalComingSoonV2.vue?vue&type=template&id=10a4ce72&"
import script from "./modalComingSoonV2.vue?vue&type=script&lang=js&"
export * from "./modalComingSoonV2.vue?vue&type=script&lang=js&"
import style0 from "./modalComingSoonV2.vue?vue&type=style&index=0&id=10a4ce72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports